module.exports = __webpack_public_path__ + "static/media/41.66144745.png";